module.exports = __webpack_public_path__ + "static/media/dias_accreditation_polices_procedures.f5387a96.svg";